import { createAsyncThunk } from "@reduxjs/toolkit";

import { getSite } from "@/models";
import { AppState } from "@/redux/store/store";
import { fetchAuthToken } from "@/helpers/fetch-auth-token";

export const fetchSite = createAsyncThunk(
  "site/fetchSite",
  async (params: Partial<{ config: any }>, { rejectWithValue, getState }) => {
    const { config } = params;
    const { adapter } = getState() as AppState;

    const { baseUrl } = adapter.adapter;
    const { token } = fetchAuthToken(getState());

    try {
      const response = await getSite(token, baseUrl, {}, config);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
